// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2vt--","signatureButtonsRight":"ModalSign_signatureButtonsRight__l6wja"};